'use strict';

angular.module('theme').service('StickersService', function ($q, $http, CUSTOMER) {

	this.order = function () {

		if (!CUSTOMER) {
			return $q.reject('there must be a CUSTOMER');
		}

		return $http({
			url: '/backapi/stickers',
			method: 'POST'
		}).then(function (response) {
			return response.data;
		});
	};

});
